import { render, staticRenderFns } from "./LiquidationBatchList.vue?vue&type=template&id=0ab9fff9&scoped=true&lang=pug"
import script from "./LiquidationBatchList.vue?vue&type=script&lang=js"
export * from "./LiquidationBatchList.vue?vue&type=script&lang=js"
import style0 from "./LiquidationBatchList.vue?vue&type=style&index=0&id=0ab9fff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab9fff9",
  null
  
)

export default component.exports